import { useState } from 'react';
import type { ReactNode } from 'react';
import { useTracking } from 'react-tracking';
import TableSolid from '@simplywallst/ui-core/icons/TableSolid';
import RawDataModal from '../RawDataModal';
import { RawDataButton } from './styled';

export interface Props {
  cyId?: string;
  title?: ReactNode;
  children: ReactNode;
}

export function RawData({ cyId, title, children }: Props) {
  const [visible, setVisible] = useState(false);
  const { Track, trackEvent } = useTracking({ type: 'track' });
  return (
    <Track>
      <RawDataButton
        data-cy-id={cyId || 'raw-data'}
        styleType="gentle"
        alignIcon="left"
        marginRight
        onClick={() => {
          trackEvent({
            action: 'click',
            modifier: 'rawData',
          });
          setVisible(true);
        }}
      >
        <TableSolid />
        View Data
      </RawDataButton>
      <RawDataModal
        title={title}
        isVisible={visible}
        onClose={() => setVisible(false)}
      >
        {children}
      </RawDataModal>
    </Track>
  );
}
